import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { HouseSimple, Hospital, UsersThree, GearSix, ShieldCheck } from '@phosphor-icons/react';
import Avatar from './Avatar';
import { isNative } from '../lib/platform';

const navItems = [
  { path: '/', label: 'Home', icon: HouseSimple },
  { path: '/clinics', label: 'Clinics', icon: Hospital },
  { path: '/clinicians', label: 'Clinicians', icon: UsersThree },
  { path: '/settings', label: 'Settings', icon: GearSix },
];

function NavItem({ to, end, icon: Icon, label }) {
  return (
    <NavLink to={to} end={end} className="block outline-none mb-1">
      {({ isActive }) => (
        <span
          className={`flex items-center gap-3 h-11 px-3.5 rounded-[14px] text-[15px] font-semibold transition-colors ${
            isActive ? 'bg-primary-10 text-primary' : 'text-gray-600 hover:bg-[#F3F1F8] hover:text-[#111]'
          }`}
        >
          <Icon size={21} weight={isActive ? 'fill' : 'regular'} />
          {label}
        </span>
      )}
    </NavLink>
  );
}

// Desktop sidebar. Phones use the tab bar in Layout.
export default function Sidebar({ user }) {
  const navigate = useNavigate();

  return (
    <aside className="hidden md:flex fixed left-0 top-0 h-screen w-[248px] flex-col z-10 px-4 pt-7 pb-5 bg-white border-r border-[#ECEAF2]">
      <button type="button" className="px-3 mb-8 text-left" onClick={() => navigate('/')} aria-label="Home">
        <img
          src="/cscore-logo.png"
          alt="CScore"
          style={{ height: '26px', filter: 'brightness(0) saturate(100%) invert(13%) sepia(90%) saturate(5500%) hue-rotate(270deg) brightness(80%) contrast(110%)' }}
        />
      </button>

      <nav className="flex-1">
        {navItems.map((item) => (
          <NavItem key={item.path} to={item.path} end={item.path === '/'} icon={item.icon} label={item.label} />
        ))}
        {user?.user_type === 'super_admin' && !isNative && (
          <NavItem to="/admin/users" icon={ShieldCheck} label="Admin" />
        )}
      </nav>

      <button
        type="button"
        onClick={() => navigate('/settings')}
        className="flex items-center gap-3 p-2.5 rounded-[16px] hover:bg-[#F3F1F8] transition-colors text-left"
      >
        <Avatar src={user?.profile_picture_url} name={`${user?.first_name || ''} ${user?.last_name || ''}`} size="md" />
        <div className="min-w-0">
          <p className="text-[14px] font-semibold text-[#111] truncate">{user?.first_name} {user?.last_name}</p>
          <p className="text-[12px] text-gray-500 truncate">{user?.email}</p>
        </div>
      </button>
    </aside>
  );
}
